import { render } from "./ErrorOverlay.vue?vue&type=template&id=8e7cdab6&scoped=true&ts=true"
import script from "./ErrorOverlay.vue?vue&type=script&lang=ts"
export * from "./ErrorOverlay.vue?vue&type=script&lang=ts"

import "./ErrorOverlay.vue?vue&type=style&index=0&id=8e7cdab6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e7cdab6"]])

export default __exports__